export const COLORS = {
  DUBAI_100: "#000C37",
  WHITE: "#FFF",
};

export const COLOR_PALETTE: string[] = [
  // Row 1 — very light
  "#F2F9FF",
  "#F5F6FE",
  "#F2FCFB",
  "#FEF3F6",
  "#FFF9F4",
  "#F8F9FD",
  "#F9DFFF",
  "#FFF6C1",
  // Row 2 — light pastel
  "#E6F3FF",
  "#ECEDFE",
  "#E6F8F7",
  "#FEE7EC",
  "#FFF2E8",
  "#EFF1F6",
  "#F4C6FF",
  "#FFF2A9",
  // Row 3 — medium
  "#50ADFF",
  "#868EF9",
  "#09D1C5",
  "#FF517B",
  "#FCAA6B",
  "#E0E4EC",
  "#EC97FF",
  "#FFEB7A",
  // Row 4 — vivid
  "#0088FF",
  "#5864FF",
  "#02BCB1",
  "#F52C5C",
  "#FC7E1D",
  "#C9CFDB",
  "#DF50FF",
  "#FFE75D",
  // Row 5 — dark
  "#006FF1",
  "#3F4CF1",
  "#019990",
  "#F20C43",
  "#F8501C",
  "#9EA9B9",
  "#D412FF",
  "#FFD900",
];
